import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// todo move to noddi-util -.-

// Our @theme adds breakpoints whose names are not t-shirt sizes (`mdx`, `xxs`). Unregistered,
// tailwind-merge cannot tell `max-w-screen-mdx` is a max-width, so a caller's `max-w-*`
// override was kept alongside it and lost on stylesheet order. Same for the named stacking
// layers (`--z-index-*` in noddi-ui-web's index.css); its zIndexLayers.test.ts keeps them in step.
const Z_INDEX_LAYERS = ['map', 'docked', 'overlay', 'map-control', 'fullscreen', 'dev-banner'];

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      breakpoint: ['xxs', 'mdx']
    },
    classGroups: {
      z: [{ z: Z_INDEX_LAYERS }]
    }
  }
});

// Clsx for conditional classes, will result in possible duplication of classes
// To merge duplication "intelligently" use twMerge('px-2 py-1', 'p-3') => p-3
export function cn(...inputs: ClassValue[]) {
  // `clsx` is registered as a class-carrying function, so here — where it is
  // handed the rest parameter rather than literals — the plugin reads the
  // variable's own name as a classname.
  // eslint-disable-next-line tailwindcss/no-custom-classname -- clsx gets the rest parameter, not literals, so the plugin reads the variable name as a classname
  return twMerge(clsx(inputs));
}
